// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"trending-up"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.5 16.5L8.50001 11.5L12.5 15.5L19.25 8.75001M14.5 8L20 8V13.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TrendingUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'trending-up',
    ref,
    icon: element,
  },
));

TrendingUpIcon.displayName = 'TrendingUpIcon';

export default TrendingUpIcon;
